<template>
  <div>
    <el-table
      :data="budgets"
      class="w-100"
      stripe
    >
      <!-- <el-table-column type="expand">
        <template slot-scope="props">
          <BudgetsTablePeak :budget="props.row" />
        </template>
      </el-table-column> -->

      <el-table-column
        label="Budget"
        prop="budget"
        :formatter="(row, col, cellValue) => $_.get(row, 'budget.name', '-')"
      />

      <el-table-column
        label="Target"
        prop="target"
        :formatter="(row, col, cellValue) => $_.get(row, 'target', '-')"
      />

      <el-table-column
        label="Actual"
        prop="actual"
        :formatter="(row, col, cellValue) => $_.get(row, 'actual', '-')"
      />

      <el-table-column
        label="Allocated"
        prop="allocated"
        :formatter="(row, col, cellValue) => $_.get(row, 'allocated', '-')"
      />

      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.native="editBudget(scope.row)"
          >
            Edit
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    budgets: {
      type: Array,
      required: true
    }
  },
  methods: {
    editBudget (row) {
      console.log(row)
    }
  }
}
</script>

<style>

</style>
